/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineObject5 model module.
 * @module model/InlineObject5
 * @version 1.0.0
 */
class InlineObject5 {
    /**
     * Constructs a new <code>InlineObject5</code>.
     * @alias module:model/InlineObject5
     */
    constructor() { 
        
        InlineObject5.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineObject5</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineObject5} obj Optional instance to populate.
     * @return {module:model/InlineObject5} The populated <code>InlineObject5</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineObject5();

            if (data.hasOwnProperty('nee_level_id')) {
                obj['nee_level_id'] = ApiClient.convertToType(data['nee_level_id'], 'Number');
            }
            if (data.hasOwnProperty('files')) {
                obj['files'] = ApiClient.convertToType(data['files'], File);
            }
            if (data.hasOwnProperty('more_info')) {
                obj['more_info'] = ApiClient.convertToType(data['more_info'], 'String');
            }
            if (data.hasOwnProperty('replica')) {
                obj['replica'] = ApiClient.convertToType(data['replica'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} nee_level_id
 */
InlineObject5.prototype['nee_level_id'] = undefined;

/**
 * @member {File} files
 */
InlineObject5.prototype['files'] = undefined;

/**
 * @member {String} more_info
 */
InlineObject5.prototype['more_info'] = undefined;

/**
 * @member {Boolean} replica
 */
InlineObject5.prototype['replica'] = undefined;






export default InlineObject5;

